// extracted by mini-css-extract-plugin
export var acceptButton = "_2a-6";
export var backdropBlur = "_2a-0";
export var fullContent = "_2a-5";
export var link = "_2a-7";
export var linkIcon = "_2a-8";
export var sideContent = "_2a-4";
export var sideImage = "_2a-3";
export var sideImageWrapper = "_2a-2";
export var splitLayout = "_2a-1";